import { jsx as s } from "react/jsx-runtime";
import { lazy as E } from "react";
import { isObject as w } from "@perxis-auto/shared";
import { WidgetType as l } from "@perxis-auto/trade-in-sdk/types";
import { FIELD_ELEMENT_VALUE as b } from "./Field.types.js";
const T = E(() => import("@perxis-auto/ui-kit/lib/components/Input/Input")), O = E(() => import("@perxis-auto/ui-kit/lib/components/Select/Select")), i = E(() => import("@perxis-auto/ui-kit/lib/components/Radio/Radio")), S = E(
  () => import("@perxis-auto/ui-kit/lib/components/Radio/Radio").then((f) => ({ default: f.default.Group }))
), u = E(() => import("@perxis-auto/ui-kit/lib/components/Checkbox/Checkbox"));
function U({ widgetType: f, value: r, onChange: e, options: L = [], ...d }) {
  switch (f) {
    case l.INPUT:
      return /* @__PURE__ */ s(T, { ...d, value: r, onChange: e });
    case l.SELECT: {
      const m = w(r) ? r == null ? void 0 : r.id : r;
      return /* @__PURE__ */ s(
        O,
        {
          ...d,
          value: m,
          options: L,
          onClear: () => e == null ? void 0 : e(void 0),
          onChange: (c, t) => e == null ? void 0 : e(t == null ? void 0 : t[b])
        }
      );
    }
    case l.AUTOCOMPLETE: {
      const m = w(r) ? r == null ? void 0 : r.id : r;
      return /* @__PURE__ */ s(
        O,
        {
          ...d,
          value: m,
          options: L,
          onClear: () => e == null ? void 0 : e(void 0),
          onChange: (c, t) => e == null ? void 0 : e(t == null ? void 0 : t[b]),
          showSearch: !0,
          filterOption: (c, t) => ((t == null ? void 0 : t.label) ?? "").toLowerCase().includes(c.toLowerCase()),
          filterSort: (c, t) => ((c == null ? void 0 : c.label) ?? "").toLowerCase().localeCompare(((t == null ? void 0 : t.label) ?? "").toLowerCase())
        }
      );
    }
    case l.RADIO: {
      const m = w(r) ? r == null ? void 0 : r.id : r;
      return /* @__PURE__ */ s(S, { ...d, value: m, onChange: e, children: L.map((c) => /* @__PURE__ */ s(i, { value: c.value, children: c.label }, String(c.value))) });
    }
    case l.CHECKBOX:
      return /* @__PURE__ */ s(u, { ...d, value: !!r, onChange: e });
    default:
      throw new Error("Неподдерживаемый тип виджета");
  }
}
export {
  U as FieldElement
};
